export class MessageConstants {
    // placeHolders

    // tooltip Messages
    public static readonly EffectiveVersionLinkToolTip : string = 'This link leads to the Effective Version of the Document if it exists. If there is no Effective Version, an error is returned.';
    public static readonly SpecificVersionLinkToolTip : string = 'This link leads to the Version of the Document it was generated from (i.e. this Version), regardless of the Phase of this Version or other Versions.';
    public static readonly LatestVersionLinkToolTip : string = 'This link leads to the Latest Version of the Document, regardless of the Phase of this Version or other Versions.'
    public static readonly DisabledCheckBoxConstantForCRIItems: string ='It is not possible to select Manual and Periodic Review Change Request Items at the same time.';
    public static readonly BlankToolTipConstant:string='';

    // confirmation Messages
    public static readonly Slider_Confirmation_Header: string =
      'Confirmation';
    public static readonly Slider_Confirmation_Text: string =
     'Any unsaved change will be lost when closing the screen. Do you want to continue?';

    // Custom Messages
}
